import type { DelayTime } from '@/constants';
import type { Asset } from '@/interfaces';
import type {
  PmtOnboardingPopupTrigger,
  PmtOnboardingPopupVariant,
} from '@/modules/pmt/interfaces/tracking/trackingOnboardingPopup.interfaces';
export interface ITrackingLeftPanel {
  joinUsHeader?: string;
  joinUsValuePropositionList?: Array<Asset>;
}
export interface ITrackingRightPanel {
  joinUsDesktopMainText?: string;
  joinUsSubtext?: string;
  desktopGoogleCta?: string;
  popupVariant?: string;
  subPmcNewsletterText?: string;
  newsletterSubText?: string;
  heroImage?: Asset;
  sys?: { id: string };
  zapierHookId?: string;
  newUserTriggerTimes?: Array<number> | null;
  returnUserTriggerTimes?: Array<number> | null;
  trigger?: PmtOnboardingPopupTrigger;
  variant?: PmtOnboardingPopupVariant;
  loginByEmail?: boolean;
  identifier?: string;
  onNext?: () => void;
  onClose?: () => void;

  // For GTM
  delayTime?: DelayTime;
}

export type IPmtOnboardingPopup = ITrackingLeftPanel & ITrackingRightPanel;

export enum PmtSignUpStep {
  SignUp = 'Sign Up',
  VerifyEmail = 'Verify Email',
  Success = 'Success',
}

export enum PmtOnboardingPopupCta {
  Noti = 'noti',
  Login = 'login',
  DelayedShipment = 'delayed shipment',
  ShipmentSummary = 'shipment summary',
  LandingPage = 'landing_page',
}
